import type { FC, ReactNode } from 'react';
import type { TextProps } from 'react-native-paper';
import { Text } from 'react-native-paper';

type NavigationBarDefaultTitleProps = {
  title: string;
  subTitle?: ReactNode;
  /** Resolved title color (`titleColor ?? defaultColor` of the bar). */
  titleColor: string;
  /** Resolved subtitle color (`subTitleColor ?? defaultColor` of the bar). */
  subTitleColor: string;
  titleVariant?: TextProps<string>['variant'];
  subTitleVariant?: TextProps<string>['variant'];
};

/**
 * Standard textual navigation bar title (+ optional subtitle).
 *
 * This is the default title rendering of `NavigationBar`. A custom
 * `titleComponent` replaces it entirely; embed this component when you only
 * want to add content around the default title.
 */
export const NavigationBarDefaultTitle: FC<NavigationBarDefaultTitleProps> = ({
  title,
  subTitle,
  titleColor,
  subTitleColor,
  titleVariant = 'titleLarge',
  subTitleVariant = 'bodyMedium'
}) => (
  <>
    <Text
      variant={titleVariant}
      style={{ color: titleColor }}
      numberOfLines={1}
    >
      {title}
    </Text>
    {subTitle && (
      <Text variant={subTitleVariant} style={{ color: subTitleColor }}>
        {subTitle}
      </Text>
    )}
  </>
);
